import { render } from "./KontonummerValidator.vue?vue&type=template&id=7731d326&scoped=true"
import script from "./KontonummerValidator.vue?vue&type=script&lang=js"
export * from "./KontonummerValidator.vue?vue&type=script&lang=js"

import "./KontonummerValidator.vue?vue&type=style&index=0&id=7731d326&scoped=true&lang=css"

import exportComponent from "/home/ola/DevelopmentProjects/testdatano/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7731d326"]])

export default __exports__